'use strict';

import isSuperAdmin from './isSuperAdmin';
import getUID from './getUID';
import jwt from 'jsonwebtoken';
import tokenOptions from '../../config/jwt.config';

const JWT = {
    
    sign(superAdmin, uuid = null, subscriptionID = null) {
        return jwt.sign({
            isSuperAdmin: superAdmin,
            UUID: uuid,
            subscriptionID: subscriptionID
        }, process.env.VUE_APP_JWT_KEY, tokenOptions);
    },

    decode(token) {
        return jwt.decode(token);
    },

    async verify() {
        let superAdmin = isSuperAdmin(localStorage.getItem('superAdmin'));
        let uuid = superAdmin === true ? null : await getUID();

        jwt.verify(localStorage.getItem('superAdmin'), process.env.VUE_APP_JWT_KEY, tokenOptions, async (err) => {
            if (err) {
                // If it is valid but just expired, renew it
                if (err.name === 'TokenExpiredError') {
                    localStorage.setItem('superAdmin', this.sign(superAdmin, uuid));
                }
            }
        });
    }
}

export default JWT;